<app-simple-modal [title]="'Agregar Series'" [max]="40" (close)="close.emit($event)">
	<div fields>
		<div class="form-group">
			<label for="serie" class="form-label">Serie</label>
			<div class="input-group">
				<input type="text" id="serie" [(ngModel)]="tempSeriesName" placeholder="Ingresa o escanea una serie" name="serie" class="form-control">
				<button class="btn btn-primary" (click)="addTempSerie()" [disabled]="!tempSeriesName"><i
						class="fa fa-circle-plus"></i></button>
			</div>
		</div>
		<div class="table-responsive mt-1" *ngIf="newListSeries.dataSeries.length > 0">
			<table class="table table-striped">
				<thead>
					<tr class="tr-middle">
						<th>Serie</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let serie of newListSeries.dataSeries; let i = index">
						<td>
							<div class="form-group">
								<label for="series" class="form-label">{{serie.series}}</label>
								<p class="form-text" style="font-size: 0.8em;" *ngIf="serie.dataSeries">
									<i class="fa fa-calendar"></i>
									{{serie.dataSeries.dateAssociated | date: 'dd/MM/YYYY'}}
								</p>
							</div>
						</td>
						<td style="max-width: 40px;">
							<span class="text-danger" *ngIf="!serie.dataSeries || serie.dataSeries?.clientInvoice == null ">
								<i *ngIf="!deleting[serie.series]" (click)="removeSerie(i)" class="clickeable fa fa-trash"></i>
								<span *ngIf="deleting[serie.series]" class="spinner-border spinner-border-sm"></span>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" [disabled]="newListSeries.dataSeries.length == 0"
			(clicked)="saveSeries()"></app-loading-button>
	</div>
</app-simple-modal>